<!--
功能: 验证码 验证

属性: 无
SLOT: code: 验证码

事件:
colseCodeModal: 对话框变化时，参数 true 或 false

案例:
    <ValidateCode v-if="isValidateCode" @colseCodeModal="colseCodeModal"/>
-->

<template>
    <div class="calidate-code" style="display: none">
        <!-- 验证码 -->
        <Modal v-model="validateCodeModal" :title="getTitle()" :closable="false" :mask-closable="false" @on-visible-change="colseCodeModal" class="mooc-charge-code-modal">
            <div class="code-div">
                <img v-show="imgCodeSrc" style="object-fit: cover;" :src="imgCodeSrc" @click="getCodeImgSrc">
                <Input v-model="code" style="width: 150px" placeholder="请输入验证码" />
                <Spin size="large" fix v-if="spinDivShow"></Spin>
            </div>
            <div slot="footer">
                <Button :loading="spinShow" class="code-btn" type="primary" @click="sendSaveCode()">提交验证码</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import GuangYuanDao from '@/../public/static/js/dao/GuangYuanDao';

export default {
    props: {
        // faceInfo : { type: Object, required: true  }, // 配置
    },
    data() {
        return {
            code             : '', // 输入的验证码
            spinShow         : false, // 提交按钮 loading
            spinDivShow      : false, // code-div loading
            imgCodeSrc       : '', // 验证码图片
            codeCount        : 1, // 验证次数
            validateCodeModal: false, // 验证码 modal
        };
    },
    created() {
    },
    mounted() {
        if (this.videoOnHook == 1 && this.triggerType != 0) {
            console.log('this.triggerType', this.triggerType);
        } else {
            var questData = this.$store.state.questData;
            let isModel = Utils.getCookie(questData.resCode + this.videoOnHook);
            if (isModel) {
                this.getCodeImgSrc();
            }
        }
    },
    computed: {
        // 触发方式, 0 = 固定次数, 1 = 固定时间, 2 = 每次递增
        triggerType() {
            return this.$store.state.recordConfig.triggerType;
        },
        // 触发的值，根据类型 triggerType 来设置：当 triggerType = 0 时，表示是按照次数来，当 triggerType = 1 或者 triggerType = 2 时，表示时按照分钟来
        triggerValue() {
            return this.$store.state.recordConfig.triggerValue;
        },
        // 视频首次开始观看时人脸识别, 0 = 不需要, 1 = 需要
        videoStartFace() {
            return this.$store.state.recordConfig.videoStartFace;
        },
        // 是否验证码防挂机
        videoOnHook() {
            return this.$store.state.recordConfig.videoOnHook;
        },
    },
    methods: {
        // 弹窗标题
        getTitle() {
            return '验证码打卡';
        },
        // 当验证码弹窗变化时
        colseCodeModal(value) {
            this.$emit('colseCodeModal', value);
            var questData = this.$store.state.questData;
            if (value) {
                // 清空定时任务
                clearTimeout(this.codeTask);
                if (this.videoOnHook == 1 && this.triggerType == 0) {
                    Utils.setCookie(questData.resCode + this.videoOnHook, true, 12, '/page/;');
                }
            } else {
                this.$store.commit('setIsCodeloading', false);
                // 触发类型 1, 2 时, 进行定时任务
                if (this.triggerType == 1 || this.triggerType == 2) {
                    this.codeTimedTask();
                } else {
                    Utils.setCookie(questData.resCode + this.videoOnHook, false, 12, '/page/;');
                }
                // // 触发类型为 0 时, 次数未达到固定次数则进行定时任务
                // if (this.triggerType == 0 && this.codeCount < this.triggerValue) {
                //     // this.codeTimedTask();
                // }
                // 清空验证码
                this.code = '';
                this.bizCode = ''; // bizCode 用于提交人脸识别接口
                this.cardNo = ''; // 卡号
                this.expiresTime = ''; // 有效期，单位：分钟
                this.studentUserAccount = ''; //
                this.imgCodeSrc = ''; // 验证码图片地址
            }
        },
        // 验证码定时任务, 根据参数确定 多长 时间执行一次
        codeTimedTask() {
            var self = this;
            // console.log('this.triggerType', this.triggerType);
            // console.log('this.triggerValue', this.triggerValue);
            // 1 固定时间 间隔触发 triggerValue 分钟
            if (this.triggerType == 1) {
                self.codeTask = setTimeout(() => {
                    // 获取验证码
                    this.getCodeImgSrc();
                }, self.triggerValue * 60 * 1000);
            }
            // 2 每次递增
            if (this.triggerType == 2) {
                // 计算定时人脸时间
                self.startTime = self.startTime + self.triggerValue;
                self.codeTask = setTimeout(() => {
                    // 获取验证码
                    this.getCodeImgSrc();
                }, self.startTime * 60 * 1000);
            }
        },
        // 开始防挂机验证
        start() {
            // 切换章节时重置每次递增参数
            this.startTime = 0;
            if (this.codeTask) clearTimeout(this.codeTask);
            // 获取验证码
            this.getCodeImgSrc();
            console.log('getCodeImgSrc');
            // }
        },
        // 提交保存验证码
        sendSaveCode() {
            if (!this.code) {
                Utils.warning('请输入验证码!');
            } else {
                // 打开加载中
                this.spinShow = true;
                // 提交验证码
                this.submitCode();
            }
        },
        // 获取验证码
        getCodeImgSrc() {
            this.spinDivShow = true;
            var self = this;
            // 设置参数配置
            var data = this.$store.state.questData;
            data.deviceId = Utils.getUUID();
            // 获取验证码
            GuangYuanDao.invokeVerificationCode(data, (resData) => {
                self.spinShow = false;
                this.spinDivShow = false;
                const result = resData.data;
                if (resData && resData.code == 200) {
                    // Utils.success('获取验证码调用成功');
                    // console.log('获取验证码调用成功');
                    self.bizCode = result.bizCode; // bizCode 用于提交人脸识别接口
                    self.cardNo = result.cardNo; // 卡号
                    self.expiresTime = result.expiresTime; // 有效期，单位：分钟
                    self.studentUserAccount = result.studentUserAccount; //
                    self.imgCodeSrc = result.verificationImagePath; // 验证码
                    // 进行验证码验证
                    if (!self.validateCodeModal) self.validateCodeModal = true;
                    self.$store.commit('setIsCodeloading', self.validateCodeModal);
                } else {
                    Utils.error(resData.msg);
                }
            });
        },
        // 调用后台接口提交验证码
        submitCode() {
            var self = this;
            // 设置参数配置
            var data = this.$store.state.questData;
            data.verificationCode = this.code;
            data.bizCode = this.bizCode;
            data.videoStudyTime = this.$store.state.currentTime; // 当前播放时间点
            data.deviceId = Utils.getUUID();

            // 提交验证码
            GuangYuanDao.invokeVerifyCode(data, (resData) => {
                self.spinShow = false;
                data.bizCode = '';
                if (resData && resData.code == 200) {
                    // Utils.success('验证码正确');
                    self.$Message.success('验证码正确');
                    // 验证次数
                    self.codeCount++;
                    // 1 秒后自动关闭
                    setTimeout(() => {
                        // 如果弹窗打开, 则关闭
                        if (self.validateCodeModal) self.validateCodeModal = false;
                    }, 1000);
                    // 进行验证码验证
                    // if (!self.validateCodeModal) self.validateCodeModal = true;
                } else {
                    Utils.error(resData.msg);
                }
            });
        },
    },
    // 组件关闭
    destroyed() {
        clearTimeout(this.codeTask);
        console.log('验证码组件关闭');
    },
};
</script>

<style lang="scss">
.calidate-code {

}
.mooc-charge-code-modal {
    .ivu-modal-body {
        text-align: center;
    }
    img {
        // width  : 200px;
        // margin : 0 10px 10px 10px;
        justify-self: end;
    }
    .code-div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
    }
    .ivu-modal-footer {
        text-align: center;
    }

    .code-btn {
        margin          : 10px 10px 0 10px;
        color           : #fff;
        background-color: #2e8ded;
        border-color    : #2e8ded;
        font-size       : 14px;
        span {
            text-align: center;
        }
    }
}

</style>
